/* eslint-disable max-len */
import Cookies from 'js-cookie';

const LOGGED_USER_KEY = 'LOGGED_USER';
const PERMISSIONS_KEY = 'PERMISSIONS';
const LAST_VISITED_PAGE_KEY = 'LAST_VISITED_PAGE';
const AUTO_GUEST_ENABLED = 'AUTO_GUEST_ENABLED';
const DEEPLINK = 'DEEPLINK';
const SESSION_COOKIE_NAME = '_al_accessTokenValid';
const CLIENT_COOKIE_NAME = '_al_client';
const ROTATION_STATIONS = 'ROTATION_STATIONS';
const ROTATION_MINUTES = 'ROTATION_MINUTES';

export const useAllieStorage = () => {
  const setLoggedUser = (loggedUser: any) => (
    localStorage.setItem(LOGGED_USER_KEY, JSON.stringify(loggedUser))
  );

  const getLoggedUser = () => JSON.parse(localStorage.getItem(LOGGED_USER_KEY) || '{}');

  const clearLoggedUser = () => localStorage.setItem(LOGGED_USER_KEY, '{}');

  const setPermissions = (permissions: any) => (
    localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions))
  );

  const getPermissions = () => JSON.parse(localStorage.getItem(PERMISSIONS_KEY) || '[]');

  const clearPermissions = () => localStorage.setItem(PERMISSIONS_KEY, '[]');

  const clearAuthData = () => {
    clearLoggedUser();
    clearPermissions();
  }

  const setLastVisitedPage = (lastPage: Record<string, unknown>) => {
    localStorage.setItem(LAST_VISITED_PAGE_KEY, JSON.stringify(lastPage));
  };

  const getLastVisitedPage = () => (
    JSON.parse(localStorage.getItem(LAST_VISITED_PAGE_KEY) || '{}')
  );

  const setAutoGuestEnabled = (enabled: boolean) => (
    localStorage.setItem(AUTO_GUEST_ENABLED, `${enabled}`)
  );

  const getAutoGuestEnabled = (): boolean => localStorage.getItem(AUTO_GUEST_ENABLED) === 'true';

  const getSessionExpiresAt = (): number => Number(Cookies.get(SESSION_COOKIE_NAME));

  const getAppClient = (): string => Cookies.get(CLIENT_COOKIE_NAME) || '';

  const setDeeplink = (deeplink: string) => localStorage.setItem(DEEPLINK, deeplink);

  const getDeeplink = (): string | null => {
    const deeplink = localStorage.getItem(DEEPLINK);
    localStorage.setItem(DEEPLINK, '');
    return deeplink !== '' ? deeplink : null;
  };

  const setStationsRotation = (stationIds: number[]) =>
    localStorage.setItem(ROTATION_STATIONS, JSON.stringify(stationIds));

  const getStationsRotation = () => JSON.parse(localStorage.getItem(ROTATION_STATIONS) || '[]');

  const setRotationMinutes = (minutes: number) =>
    localStorage.setItem(ROTATION_MINUTES, `${minutes}`);

  const getRotationMinutes = () => Number(JSON.parse(localStorage.getItem(ROTATION_MINUTES) || '0' ));

  return {
    setLoggedUser,
    getLoggedUser,
    setPermissions,
    getPermissions,
    clearAuthData,
    setLastVisitedPage,
    getLastVisitedPage,
    getSessionExpiresAt,
    setAutoGuestEnabled,
    getAutoGuestEnabled,
    setDeeplink,
    getDeeplink,
    getAppClient,
    setStationsRotation,
    getStationsRotation,
    setRotationMinutes,
    getRotationMinutes,
  };
};
